import { ConfirmationDialog } from "components";
import { connect, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { deleteReadingMaterial } from "../store/action";
import { ReadingMaterialProps } from "../store/actionType";

interface OwbProps {
  readingMaterial: ReadingMaterialProps| null | undefined;
  closeModal: React.Dispatch<React.SetStateAction<boolean>>;
}
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & OwbProps;
const HandleDeleteReadingMaterial:React.FC<Props> = ({ readingMaterial, onDeleteRM, closeModal}) =>{
   const readingMaterialState = useSelector(
    (state: any) => state.readingMaterial?.readingMaterialState
  );
  const [deleteError, setDeleteError] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const handleDeleteVideo = (e: any) => {
    e.stopPropagation();
    if (!readingMaterial?.id) return; 
  onDeleteRM(readingMaterial.id.toString())
    setSubmitted(true);
  };
  useEffect(() => {
    if (submitted) {
      setDeleteError(readingMaterialState?.error);
      if (readingMaterialState?.delete) {
        closeModal(false);
      } else if (readingMaterialState.error) {
        closeModal(true);
      }
    }
  }, [readingMaterialState?.delete, submitted]);
  return (
    <>
      <ConfirmationDialog
        title={"Delete Reading Material"}
        message={"Are you sure you want to delete?"}
        onConfirm={handleDeleteVideo}
        onCancel={() => closeModal(false)}
        error={deleteError}
      />
    </>
  );
};
const mapDispatchToProps = (dispatch: any) => ({
  onDeleteRM: (materialId: string) => dispatch(deleteReadingMaterial(materialId)),
});

export default connect(null, mapDispatchToProps)(HandleDeleteReadingMaterial);